import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import { formatCurrency } from '../../../utils/currency';
import { isPriceLabel } from '../../../utils/currency/currency';
export function createSelectionRangeDescription(min, max) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$includeParenthes = _ref.includeParenthesis,
    includeParenthesis = _ref$includeParenthes === void 0 ? true : _ref$includeParenthes;
  var range = '';
  if (_isNumber(min) && min && _isNumber(max)) {
    if (min === max) {
      range = "Pick ".concat(min);
    } else {
      range = "Pick ".concat(min, " to ").concat(max);
    }
  } else if (_isNumber(min) && min) {
    range = "Pick at least ".concat(min);
  } else if (_isNumber(max) && max > 0) {
    range = "Pick up to ".concat(max);
  }
  if (includeParenthesis && !_isEmpty(range)) {
    range = "(".concat(range, ")");
  }
  return range;
}
export function formatModifierPrice(price) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$noPriceLabel = _ref2.noPriceLabel,
    noPriceLabel = _ref2$noPriceLabel === void 0 ? '-' : _ref2$noPriceLabel,
    _ref2$displayZeroCost = _ref2.displayZeroCost,
    displayZeroCost = _ref2$displayZeroCost === void 0 ? true : _ref2$displayZeroCost;
  if (_isNil(price)) {
    return noPriceLabel;
  }
  if (isPriceLabel(price)) {
    return price;
  }
  var parsedPrice = +price;
  if (parsedPrice === 0 && !displayZeroCost) {
    return noPriceLabel;
  }
  if (price < 0) {
    return formatCurrency(price);
  }
  return "+".concat(formatCurrency(price));
}